import { createFileRoute } from "@tanstack/react-router"

import { DealershipHome } from "@/components/home/dealership-home"

export const Route = createFileRoute("/$dealership/")({
  staticData: {
    breadcrumb: "Home",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { dealership, stores, user, isSuperAdmin } = Route.useRouteContext()
  if (!dealership) return null
  return (
    <div className="px-4 lg:px-6">
      <DealershipHome
        dealership={dealership}
        stores={stores}
        user={user}
        isSuperAdmin={isSuperAdmin}
      />
    </div>
  )
}
